import { Gender } from "src/domains";

export const genderList = [
  { key: Gender.MALE, label: "男性" },
  { key: Gender.FEMALE, label: "女性" },
  { key: Gender.UNDEFINED, label: "指定しない" },
];

export const genderListWithAll = [{ key: null, label: "全て" }, ...genderList];

export const prefectureList = [
  { key: "北海道", label: "北海道" },
  { key: "青森県", label: "青森県" },
  { key: "岩手県", label: "岩手県" },
  { key: "宮城県", label: "宮城県" },
  { key: "秋田県", label: "秋田県" },
  { key: "山形県", label: "山形県" },
  { key: "福島県", label: "福島県" },
  { key: "茨城県", label: "茨城県" },
  { key: "栃木県", label: "栃木県" },
  { key: "群馬県", label: "群馬県" },
  { key: "埼玉県", label: "埼玉県" },
  { key: "千葉県", label: "千葉県" },
  { key: "東京都", label: "東京都" },
  { key: "神奈川県", label: "神奈川県" },
  { key: "新潟県", label: "新潟県" },
  { key: "富山県", label: "富山県" },
  { key: "石川県", label: "石川県" },
  { key: "福井県", label: "福井県" },
  { key: "山梨県", label: "山梨県" },
  { key: "長野県", label: "長野県" },
  { key: "岐阜県", label: "岐阜県" },
  { key: "静岡県", label: "静岡県" },
  { key: "愛知県", label: "愛知県" },
  { key: "三重県", label: "三重県" },
  { key: "滋賀県", label: "滋賀県" },
  { key: "京都府", label: "京都府" },
  { key: "大阪府", label: "大阪府" },
  { key: "兵庫県", label: "兵庫県" },
  { key: "奈良県", label: "奈良県" },
  { key: "和歌山県", label: "和歌山県" },
  { key: "鳥取県", label: "鳥取県" },
  { key: "島根県", label: "島根県" },
  { key: "岡山県", label: "岡山県" },
  { key: "広島県", label: "広島県" },
  { key: "山口県", label: "山口県" },
  { key: "徳島県", label: "徳島県" },
  { key: "香川県", label: "香川県" },
  { key: "愛媛県", label: "愛媛県" },
  { key: "高知県", label: "高知県" },
  { key: "福岡県", label: "福岡県" },
  { key: "佐賀県", label: "佐賀県" },
  { key: "長崎県", label: "長崎県" },
  { key: "熊本県", label: "熊本県" },
  { key: "大分県", label: "大分県" },
  { key: "宮崎県", label: "宮崎県" },
  { key: "鹿児島県", label: "鹿児島県" },
  { key: "沖縄県", label: "沖縄県" },
];

export const prefectureListWithAll = [
  { key: null, label: "全て" },
  ...prefectureList,
];

export const bankAccountTypeList = [
  { key: "1", label: "普通" },
  { key: "2", label: "当座" },
  { key: "4", label: "貯蓄" },
];

export const statusList = [
  { key: "ACTIVE", label: "アクティブ" },
  { key: "OFFERABLE", label: "トーク申込可能" },
  { key: "LOGOUT", label: "ログアウト" },
];

export const statusListWithAll = [{ key: null, label: "全て" }, ...statusList];

export const categoryList = [
  { key: "1", label: "雑談" },
  { key: "2", label: "愚痴聞き" },
  { key: "3", label: "占い" },
  { key: "4", label: "悩み相談" },
  { key: "5", label: "恋愛相談" },
  { key: "6", label: "結婚相談" },
  { key: "7", label: "子育相談" },
  { key: "8", label: "介護相談" },
  { key: "9", label: "病気相談" },
  { key: "10", label: "お金相談" },
  { key: "11", label: "仕事相談" },
  { key: "12", label: "趣味" },
  { key: "13", label: "旅行" },
  { key: "14", label: "車" },
  { key: "15", label: "住宅" },
  { key: "16", label: "地域" },
  { key: "17", label: "小学受験" },
  { key: "18", label: "中学受験" },
  { key: "19", label: "高校受験" },
  { key: "20", label: "大学受験" },
  { key: "21", label: "就職活動" },
  { key: "22", label: "転職活動" },
  { key: "23", label: "起業" },
  { key: "24", label: "英会話・外国語" },
  { key: "25", label: "ヒアリング調査" },
  { key: "26", label: "電話彼女" },
  { key: "27", label: "電話彼氏" },
  { key: "28", label: "海外移住" },
];

export const categoryListWithAll = [
  { key: null, label: "全て" },
  ...categoryList,
];

export const ageList = [
  { key: "10", label: "10代" },
  { key: "20", label: "20代" },
  { key: "30", label: "30代" },
  { key: "40", label: "40代" },
  { key: "50", label: "50代" },
  { key: "60", label: "60代" },
  { key: "70", label: "70代〜" },
];

export const ageListWithAll = [{ key: null, label: "全て" }, ...ageList];

export const orderList = [
  { key: "SERVICE_RECOMMENDATION", label: "おすすめ" },
  { key: "SERVICE_UPDATED", label: "サービス情報の更新日順" },
  { key: "SERVICE_USAGE_COUNT", label: "人気順" },
];

export const priceList = [
  { key: "20", price: 20, label: "¥20 / 1分" },
  { key: "40", price: 40, label: "¥40 / 1分" },
  { key: "60", price: 60, label: "¥60 / 1分" },
  { key: "80", price: 80, label: "¥80 / 1分" },
  { key: "100", price: 100, label: "¥100 / 1分" },
  { key: "150", price: 150, label: "¥150 / 1分" },
  { key: "200", price: 200, label: "¥200 / 1分" },
  { key: "300", price: 300, label: "¥300 / 1分" },
  { key: "400", price: 400, label: "¥400 / 1分" },
  { key: "500", price: 500, label: "¥500 / 1分" },
];
